import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import callAPI from '../../../../api';

export const getCitiesNearestByName = createAsyncThunk(
  'cities/getCitiesNearestByName',
  async (nearestName, { rejectWithValue }) => {
    try {
      const { data } = await callAPI({ method: 'GET', url: `cities/nearest/${nearestName}` });
      return data;
    } catch (error) {
      // Reject with the error response to handle it in the reducer
      return rejectWithValue(error.response);
    }
  },
);

const INITIAL_STATE = [{ label: '', id: undefined }];

export const citiesSlice = createSlice({
  name: 'cities',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCitiesNearestByName.fulfilled, (state, { payload }) => {
        return payload.map((city) => {
          return { label: `${city.name} - ${city.uf}`, id: city.id };
        });
      })
      .addCase(getCitiesNearestByName.rejected, (state, { payload }) => {
        // Check if the error is an authentication error (e.g., 401)
        console.debug('etCitiesNearestByName.rejected', payload);
        if (payload?.status === 401 || payload?.status === 403) {
          // Redirect to the login page
          window.location.href = '/login';
        }
      });
  },
});

export default citiesSlice.reducer;
